import { z } from "zod";

export const ResellerApplicationFormSchema = z.object({
  firstName: z.string().min(1, "Bitte gib den Namen des Ansprechpartners ein."),
  lastName: z.string().min(1, "Bitte gib deinen Nachnamen des Ansprechpartners ein."),
  organization: z.string().min(1, "Bitte gib den Namen deines Unternehmens ein."),
  mail: z.email({ message: "Bitte gib eine gültige E-Mail-Adresse ein." }),
  phone: z.string().min(1, "Bitte gib eine Telefonnummer ein."),
  message: z.string().min(1, "Bitte gib dein Anliegen ein."),
});

export type ResellerApplicationFormBody = z.infer<typeof ResellerApplicationFormSchema>;
